import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth();

  console.log(isAuthenticated,'isAuthenticated43')
  if (isAuthenticated) {
    return <Navigate to={PATH_DASHBOARD.app} />;
  }
  // if (isAuthenticated) {
  //   return <Navigate to={PATH_DASHBOARD.user.general.profile} />;
  // }

  return <>{children}</>;
}
